// extracted by mini-css-extract-plugin
export default {"configuration":"Configuration_configuration__+g+bc"};